// extracted by mini-css-extract-plugin
export default {"header":"newExternalAddress_header__Foh13","active":"newExternalAddress_active__qGZ-0","modal":"newExternalAddress_modal__lSqCg"};